import React, { useEffect, useState } from "react";
import axios from "axios";
import { Input, Form, Button } from "antd";
import logoSrc from "../asset/images/login_logo.png";
import LockImgSrc from "../asset/images/secure-website.png";
import { useHistory } from "react-router-dom";
import { settings } from "../Components/utils/Settings";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const [currentUsername, setCurrentUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpLogin, setOtpLogin] = useState(false);
  const [activeForm, setActiveForm] = useState(1);

  const history = useHistory();

  useEffect(() => {
    document.title = "Login";
  });

  const formSubmitLogin = (e) => {
    e.preventDefault();

    const errorMsgElem = document.getElementById("error_msg");
    errorMsgElem.innerHTML = "";

    if (username === "") {
      errorMsgElem.innerHTML = "Username is required";
    }

    if (password === "") {
      errorMsgElem.innerHTML = "Password is required";
    }

    if (username === "" && password === "") {
      errorMsgElem.innerHTML = "Username & Password is required";
    } else {
      setLoading(true);

      const loginData = new FormData();

      loginData.append("username", username);
      loginData.append("password", password);

      axios
        .post(`${settings.API_HOST}/rest/login`, loginData)
        .then((res) => {
          if (
            !res.data.loginStatus &&
            res.data.message === " Invalid username and/or password."
          ) {
            errorMsgElem.innerHTML = res.data.message;
          } else {
            setCurrentUsername(res.data.username);
            setActiveForm(2);
            setUsername("");
            setPassword("");
            document.getElementById("otp_msg").innerHTML = res.data.message;
          }

          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          alert("Something went wrong");
        });
    }
  };

  const handleValidateToken = (e) => {
    e.preventDefault();

    const errorMsgElem = document.getElementById("error_msg");
    errorMsgElem.innerHTML = "";

    if (token === "") {
      errorMsgElem.innerHTML = "Token is required";
    } else {
      setLoading(true);
      const tokenData = new FormData();
      tokenData.append("oneTimePassword", token);
      tokenData.append("username", currentUsername);

      axios
        .post(`${settings.API_HOST}/rest/userAuth`, tokenData)
        .then((res) => {
          console.log(res, "From login response");
          if (
            !res.data.loginStatus &&
            res.data.message === "Authentication failed"
          ) {
            errorMsgElem.innerHTML = res.data.message + ". Invalid token!";
          } else {
            localStorage.setItem(
              "authorizationKey",
              res.data.authlogin.authorizationKey
            );
            e.preventDefault();
            console.log(res.data.authlogin);
            localStorage.setItem("userName", res.data.authlogin.userName);
            localStorage.setItem("userRole", res.data.authlogin.userRole);
            localStorage.setItem("userId", res.data.authlogin.userId);
            localStorage.setItem("schoolId", res.data.authlogin.schoolId);
            localStorage.setItem(
              "fullname",
              res.data.authlogin.firstName + " " + res.data.authlogin.lastName
            );
            // if(res.data.authlogin.userRole === 30) {
            //   history.push("/assessment");
            // } else {
            //   history.push("/attendance");
            // }
            window.location.href = "/";
          }

          setLoading(false);
        });
    }
  };

  const handleOtpSend = (e, sourceToSendToken) => {
    e.preventDefault();
    let successMsg = "";
    const success_msg = document.getElementById("success_msg");
    success_msg.innerHTML = "";
    const userId = localStorage.getItem("userId");
    const tokenData = new FormData();
    setOtpLogin(true);

    let url = "";

    if (sourceToSendToken === "email") {
      tokenData.append("username", currentUsername);
      url = `${settings.API_HOST}/rest/resendToken`;
      successMsg = "Token has been sent to your email again, please check.";
    }
    if (sourceToSendToken === "phone") {
      tokenData.append("userId", userId);
      url = `${settings.API_HOST}/rest/SendAuthTokenByMessage`;
      successMsg = "Token has been sent to your phone, please check.";
    }
    axios
      .post(`${settings.API_HOST}/rest/resendToken`, tokenData)
      .then((res) => {
        if (res.data.loginStatus) {
          success_msg.innerHTML = successMsg;
        }
        setOtpLogin(false);
      });
  };

  return (
    <div className="wrapper fadeInDown login">
      <div id="formContent">
        <div className="fadeIn first">
          <img src={logoSrc} id="icon" alt="User Icon" />
        </div>

        {activeForm === 1 ? (
          <Form
            layout="horizontal"
            className="form_main flex flex-col"
            autoComplete="off"
            onSubmit={(e) => formSubmitLogin(e)}
          >
            <div className="form-group flex sm:flex-col md:flex-col lg:flex-row sm:items-start md:items-start lg:items-center">
              {/* <label
                htmlFor="name"
                className="block lg:w-2/6  sm:w-full sm:mb-1 text-left mr-4"
              >
                USERNAME

              </label> */}
              <Form.Item name="username" label="USERNAME" className="username">
                <Input
                  type="text"
                  name="name"
                  id="name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder=""
                  className="w-full border border_custom_color  pl-3 rounded outline-none focus:ring-indigo-600 :ring-indigo-600 user-input"
                />
              </Form.Item>
            </div>
            <div className="form-group flex sm:flex-col lg:flex-row lg:items-center sm:items-start">
              {/* <label
                htmlFor="password"
                className="block lg:w-2/6 sm:w-full sm:mb-1 text-left mr-4"
              >
                PASSWORD
              </label> */}
              <Form.Item name="password" label="PASSWORD" className="user-pass">
                <Input
                  type="password"
                  name="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder=""
                  className="w-full border border_custom_color  pl-3 rounded outline-none focus:ring-indigo-600 :ring-indigo-600 user-password"
                />
              </Form.Item>
            </div>
            <div className="form-group">
              <span className="disable-login" id="error_msg"></span>
            </div>
            <div className="form-group flex items-center justify-center">
              <Button
                type="button"
                className="loginbtn px-8 py-2 text-white rounded"
                onClick={(e) => formSubmitLogin(e)}
                disabled={loading ? true : false}
              >
                {loading ? <div className="spinner"></div> : "LOGIN"}
              </Button>
            </div>
            <div className="form-group row otherLinks">
              <div className="col-sm-12 mt-6">
                <ul className="loginLink flex md:flex-row sm:flex-col justify-around md:items-end sm:items-center text-sm">
                  <li className="sm:mb-3 md:mb-0">
                    <a
                      className="forgot_link"
                      href="https://www.assetforschools.com/forgotusername"
                    >
                      Forgot username?{" "}
                    </a>
                  </li>
                  <li className="sm:mb-3 md:mb-0">
                    {" "}
                    <a
                      className="forgot_link"
                      href="https://www.assetforschools.com/ResetPassword-1"
                    >
                      Forgot password?
                    </a>
                  </li>
                  <li className="flex flex-row items-center">
                    {" "}
                    <img
                      src={LockImgSrc}
                      alt=""
                      className="lock_image mr-2 mr-2"
                    />
                    <span className="secureWebsite">Secure Website</span>
                  </li>
                </ul>
              </div>
            </div>
          </Form>
        ) : (
          <Form
            className="form_main flex flex-col"
            action="logon"
            focus="token"
            method="post"
            id="frm"
            autoComplete="off"
          >
            <div className="form-group">
              <span className="disable-login" id="error_msg"></span>
            </div>

            <div className="form-group flex items-center justifty-center text-center">
              <span
                className="disable-login text-green-700"
                id="success_msg"
              ></span>
            </div>

            <div className="form-group flex sm:flex-col lg:flex-row lg:items-center sm:items-start token-inp">
              <Form.Item name="token" label="TOKEN" className="tokenid">
                {/* <label
                for="token"
                className="block lg:w-2/6 sm:w-full sm:mb-1 text-left mr-4"
              >
                Token
              </label> */}
                <Input
                  type="text"
                  name="token"
                  id="token"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  className="w-full border border_custom_color  pl-3 rounded outline-none focus:ring-indigo-600 :ring-indigo-600 user-token"
                />
              </Form.Item>

              <Button
                type="button"
                className="lg:ml-6 sm:ml-0 md:ml-0 sm:mt-4 md:mt-4 lg:mt-0 w-2/6 loginbtn px-8  text-white rounded"
                style={{ height: "34px" }}
                onClick={(e) => handleValidateToken(e)}
                disabled={loading ? true : false}
              >
                {loading ? <div className="spinner"></div> : "LOGIN"}
              </Button>
            </div>

            <div className="form-group flex items-center justifty-center text-center">
              <span
                className="disable-login text-green-700"
                id="otp_msg"
              ></span>
              <a
                className="support-mail"
                href="mailto:virtualschools@assetforschools.co.uk"
              >
                virtualschools@assetforschools.co.uk
              </a>
            </div>

            <div className="form-group flex items-center justify-center gap-4">
              <button
                type="button"
                onClick={(e) => handleOtpSend(e, "email")}
                className="loginbtn px-8 py-2 text-white rounded"
              >
                {otpLogin ? <div className="spinner"></div> : "Resend token"}
              </button>
              <button
                type="button"
                onClick={(e) => handleOtpSend(e, "phone")}
                className="loginbtn px-8 py-2 text-white rounded"
              >
                {otpLogin ? (
                  <div className="spinner"></div>
                ) : (
                  "Receive token via SMS"
                )}
              </button>
            </div>
            <div className="form-group row otherLinks">
              <div className="col-sm-12 mt-6">
                <ul className="loginLink flex md:flex-row sm:flex-col justify-around md:items-end sm:items-center text-sm">
                  <li className="sm:mb-3 md:mb-0">
                    <a
                      className="forgot_link"
                      href="https://www.assetforschools.com/forgotusername"
                    >
                      Forgot username?{" "}
                    </a>
                  </li>
                  <li className="sm:mb-3 md:mb-0">
                    {" "}
                    <a
                      className="forgot_link"
                      href="https://www.assetforschools.com/ResetPassword-1"
                    >
                      Forgot password?
                    </a>
                  </li>
                  <li className="flex flex-row items-center">
                    {" "}
                    <img
                      src={LockImgSrc}
                      alt=""
                      className="lock_image mr-2 mr-2"
                    />
                    <span className="secureWebsite">Secure Website</span>
                  </li>
                </ul>
              </div>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default Login;
